import { api } from './api';
import { SubscriptionAddon, AvailableAddon } from '../types/subscription';

class AddonService {
  private baseUrl = '/v1/payment';

  /**
   * Get all available addons that can be purchased
   */
  async getAvailableAddons(): Promise<AvailableAddon[]> {
    const response = await api.get(`${this.baseUrl}/addons`);
    return response.data;
  }

  /**
   * Get all active addons for a subscription
   */
  async getSubscriptionAddons(subscriptionId: number): Promise<SubscriptionAddon[]> {
    const response = await api.get(`${this.baseUrl}/subscription/${subscriptionId}/addons`);
    return response.data;
  }

  /**
   * Purchase an addon for a subscription
   * If paymentMethodId is provided, it will be used (for new subscriptions without payment method)
   * Otherwise, Stripe will use the existing payment method from the subscription
   */
  async purchaseAddon(
    subscriptionId: number,
    addonType: string,
    paymentMethodId?: string
  ): Promise<SubscriptionAddon> {
    const response = await api.post(
      `${this.baseUrl}/subscription/${subscriptionId}/addons/${addonType}`,
      paymentMethodId ? { payment_method_id: paymentMethodId } : {}
    );
    return response.data;
  }

  /**
   * Cancel an addon
   */
  async cancelAddon(subscriptionId: number, addonId: number): Promise<{ message: string }> {
    const response = await api.delete(
      `${this.baseUrl}/subscription/${subscriptionId}/addons/${addonId}`
    );
    return response.data;
  }

  /**
   * Get addon information by type
   */
  async getAddonInfo(addonType: string): Promise<AvailableAddon | null> {
    try {
      const response = await api.get(`${this.baseUrl}/addons/${addonType}`);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch addon info for ${addonType}:`, error);
      return null;
    }
  }
}

export const addonService = new AddonService();
export default addonService;

